import { render, staticRenderFns } from "./pop-up-compatible.vue?vue&type=template&id=c9908a3c&scoped=true"
import script from "./pop-up-compatible.vue?vue&type=script&lang=js"
export * from "./pop-up-compatible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9908a3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9908a3c')) {
      api.createRecord('c9908a3c', component.options)
    } else {
      api.reload('c9908a3c', component.options)
    }
    module.hot.accept("./pop-up-compatible.vue?vue&type=template&id=c9908a3c&scoped=true", function () {
      api.rerender('c9908a3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Campaign/TabPrize/components/NotVeryCompatible/pop-up-compatible.vue"
export default component.exports